import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://createbylumera.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
const SITE_NAME = 'Create by Lumera';

/**
 * Dynamic SEO meta tags for any page.
 * Updates OG/Twitter/canonical tags client-side.
 * For full crawler support, the backend also serves OG tags at /api/p/:slug.
 */
export const PageMeta = ({
  title,
  description,
  image,
  url,
  type = 'website',
}) => {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
  const ogImage = image || DEFAULT_OG_IMAGE;
  const canonicalUrl = url ? `${SITE_URL}${url}` : SITE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title || SITE_NAME} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || SITE_NAME} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
